module.exports = __webpack_public_path__ + "static/media/chalkboard-teacher.f8b0420c.svg";